import React, { useState } from 'react';
import { InfoCard } from '@backstage/core-components';
import { useUser } from '../userManagement/hooks';
import { Box, Grid, IconButton } from '@material-ui/core';
import { useUserProfile } from '@backstage/plugin-user-settings';
import { LabelWithLoader } from './LabelWithLoader';
import { NameLabel, StyledAvatar } from './UserSettingsInfoCard.styles';

import { EditUserModal } from './UserSettingsModal';
import EditIcon from '@material-ui/icons/Edit';
import {
  getLocaleName,
  getDateFormatDisplayName,
  getTimeZoneDisplayName,
} from './preferencesOptions';

export const UserSettingsInfoCard = () => {
  const { profile, displayName } = useUserProfile();
  const { data: user, isLoading } = useUser('me');
  const [isEditMenuOpen, setIsEditMenuOpen] = useState(false);

  const handleEdit = () => {
    setIsEditMenuOpen(true);
  };

  return (
    <InfoCard title="Profile" variant="gridItem">
      <Grid container direction="row" spacing={6}>
        <Grid item>
          <StyledAvatar src={profile?.picture ?? ''} alt="Profile picture" />
        </Grid>

        <Grid item xs={12} sm container direction="column" spacing={2}>
          <Grid item>
            <NameLabel>{displayName}</NameLabel>
            <Box display="flex" flexDirection="row" gridColumnGap={120}>
              <Box display="flex" flexDirection="column" gridRowGap={24}>
                <LabelWithLoader
                  label="Email"
                  value={user?.email}
                  loading={isLoading}
                />
                <LabelWithLoader
                  label="Phone Number"
                  value={user?.phoneNumber}
                  loading={isLoading}
                />
                <LabelWithLoader
                  label="Company"
                  value={user?.companyName}
                  loading={isLoading}
                />
              </Box>

              <Box display="flex" flexDirection="column" gridRowGap={24}>
                <LabelWithLoader
                  label="Language"
                  value={getLocaleName(user?.locale ?? '')}
                  loading={isLoading}
                />
                <LabelWithLoader
                  label="Time Zone"
                  value={getTimeZoneDisplayName(user?.zoneInfo)}
                  loading={isLoading}
                />
                <LabelWithLoader
                  label="Time format"
                  value={
                    user?.is24HourFormat
                      ? '24-hour clock (e.g. 14:00)'
                      : '12-hour clock (e.g. 2:00pm)'
                  }
                  loading={isLoading}
                />
                <LabelWithLoader
                  label="Date format"
                  value={getDateFormatDisplayName(user?.dateFormat)}
                  loading={isLoading}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Grid item>
          <IconButton data-testid="user-settings-menu" onClick={handleEdit}>
            <EditIcon color="primary" />
          </IconButton>
        </Grid>
      </Grid>
      <EditUserModal
        open={isEditMenuOpen}
        onClose={() => setIsEditMenuOpen(false)}
      />
    </InfoCard>
  );
};
